module.exports = new __parcel__URL__("reports.5904cc5a.svg").toString();